import { Position, Toaster } from '@blueprintjs/core';

export const AppToaster = Toaster.create({
  className: 'toaster',
  position: Position.BOTTOM_RIGHT,
});
